import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderPublic } from '../../../../globalTypes/order.types';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Base } from '../../component/wrapper/base-wrapper.component';
import { accountFeature } from '../../store/account.store';
import { takeUntil } from 'rxjs';
import { LocationPublic } from '../../../../globalTypes/account.types';
import { NameTagComponent } from "../../component/layout/element/name.tag.component";
import { getOverlap, getRotation, getZIndex } from '../../helper/general';
import { AccountService } from '../../services/account.service';
import { dateTimeFormat, Status } from '../../../../globalTypes/base.types';
import { Fulfillment, FulfillmentStatusType } from '../../../../globalTypes/fulfillment.types';
import { ButtonComponent, ButtonDisplay } from "../../component/layout/element/button.component";
import { RatingComponent } from "../../component/review/rating.component";
import { ReviewForEdit } from '../../../../globalTypes/review.types';
import { LOCATION_LABEL } from '../../../../globalTypes/configs';

@Component({
  selector: 'msh-fulfillment-order-entry',
  imports: [CurrencyPipe, CommonModule, NameTagComponent, ButtonComponent, RatingComponent],
  template: `
@if(order){
<div class=" border-b border-navy/25 pt-8 px-6 rounded pb-8 hover:bg-copy/5 cursor-pointer" (click)="viewFulfillment()">
  <div class="flex items-center flex-wrap gap-4 mb-6">
    <div>
      <div class="flex items-center gap-4">
        <div class=" uppercase font-extrabold text-xl">Order&nbsp;#{{order.orderNumber}}</div>
        <div class=" uppercase text-xs font-bold flex flex-wrap">Transaction &nbsp;<span class=" opacity-50">#{{order.paymentTransactionId}}</span></div>
      </div>
      <div class=" text-sm opacity-50 mt-1">
        CREATED: {{ order.createdAt | date:dateTimeFormat}}
      </div>
    </div>
    
    <div class="grow"></div>
    <div class=" font-extrabold text-xl">{{order.totalAmount | currency}}</div>
    <div>
    @if(locations[order.buyerId] && locations[order.buyerId].name){
      <msh-name-tag
        [size]="'small'"
        [label]="locations[order.buyerId].name"
        [url]="locations[order.buyerId].profileImage?.url"
      ></msh-name-tag>
    } @else {
      Inactive {{LOCATION_LABEL}} (<span class="text-xs">id: {{order.buyerId}}</span>)
    }
    </div>
  </div>
  @for(fulfillment of order.fulfillments_on_order; track fulfillment.id){
    @if(fulfillment.statusId !== 'archived'){
      <div class="flex flex-wrap items-center gap-4 mb-2">
        <div class="gap-2 flex flex-col">
          <div class="flex flex-wrap gap-2">
            Fulfillment&nbsp;#{{fulfillment.fulfillmentNumber}}
            <div class=" text-orange-400">{{fulfillmentStatusMap[fulfillment.statusId] ? fulfillmentStatusMap[fulfillment.statusId].description : fulfillment.statusId}}</div>
          </div>

          @if(buyerReviews[fulfillment.id]){
            <div class="flex gap-2 text-sm text-copy">Buyer Review: 
              <msh-rating [small]="true" [rating]="buyerReviews[fulfillment.id].rating" [readonly]="true"></msh-rating>
            </div>
          }
          @if(sellerReviews[fulfillment.id]){
            <div class="flex gap-2 text-sm text-copy/50">Your Review: 
              <msh-rating [small]="true" [rating]="sellerReviews[fulfillment.id].rating" [readonly]="true"></msh-rating>
            </div>
          }
        </div>
        <div class="grow"></div>
        @if(fulfillment.parcels_on_fulfillment; as parcels){
          @for(parcel of parcels; track parcel.id){
            @if(parcel.orderItems_on_parcel; as items){
              <div>
              <div class="font-thin">{{items.length}} {{items.length === 1 ? 'item' : 'items'}}</div>
              <div class="flex">
              @for(item of items; track item.id; let i = $index){
                <div 
                  class="  w-16 h-16 bg-back flex justify-center items-center mr-6 rounded overflow-hidden bg-white"
                  [ngClass]="[
                    getOverlap(i),
                    getZIndex(i),
                    getRotation(i)
                  ]"
                >
                  <img [src]="item.listingVariation.image.url" />
                </div>
              }
                </div>
              </div>
            }

          }
        }
        <div class=" min-w-52">
          @if(ctaMap[fulfillment.statusId] && ctaMap[fulfillment.statusId]){
            <msh-button [isLoading]="takingAction" [buttonDisplayMap]="ctaMap[fulfillment.statusId]" (onClick)="actionButtonClicked($event, fulfillment)"></msh-button>
          }
        </div>
      </div> 
    }
  }
  <div></div>
</div>
}
  `,
  styles: ``
})
export class FulfillmentOrderEntryComponent extends Base<FulfillmentOrderEntryComponent> {
  @Input() order!: OrderPublic
  @Input() takingAction: boolean = false;
  @Input() ctaMap!: {[status in FulfillmentStatusType]?: ButtonDisplay } 
  @Input() buyerReviews: {[fulfillmentId: string]: ReviewForEdit} = {};
  @Input() sellerReviews: {[fulfillmentId: string]: ReviewForEdit} = {}
  @Input() fulfillmentStatusMap: {[statusId: string]: Status} = {}
  @Output() onActionTaken: EventEmitter<Fulfillment> = new EventEmitter();
  locations: {[locationId: string]: LocationPublic} = {}
  dateTimeFormat = dateTimeFormat
  getZIndex = getZIndex
  getRotation = getRotation
  getOverlap = getOverlap
  LOCATION_LABEL = LOCATION_LABEL

  constructor(
    private store: Store,
    private router: Router,
  ){
    super();
    this.store.select(accountFeature.selectLocations).pipe(takeUntil(this.$destroy)).subscribe(async locations => {
      this.locations = locations as {[locationId:string]: LocationPublic}
    })
  }

  actionButtonClicked(ev: any, fulfillment: Fulfillment){
    console.log({ev})
    this.onActionTaken.emit(fulfillment);
    ev.stopPropagation();
  }

  viewFulfillment(){
    this.router.navigate(['/order','fulfillment',this.order.id])
  }
}
